import {
  CREATE_LIVE_ACCOUNT,
  CREATE_LIVE_ACCOUNT_SUCCESS,
  CREATE_LIVE_ACCOUNT_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  moneyPlantRes: [],
};

const createLiveAccountIbReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_LIVE_ACCOUNT:
      return { ...state, loading: true };
    case CREATE_LIVE_ACCOUNT_SUCCESS:
      return {
        ...state,
        details: action?.payload,
        loading: false,
      };
    case CREATE_LIVE_ACCOUNT_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default createLiveAccountIbReducer;
